"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var cache = new Map();
/**
 * 注册计算包围盒的算法
 * @param type 方法名
 * @param method 方法
 */
function register(type, method) {
    cache.set(type, method);
}
exports.register = register;
/**
 * 获取计算包围盒的算法
 * @param type 方法名
 */
function getMethod(type) {
    return cache.get(type);
}
exports.getMethod = getMethod;
//# sourceMappingURL=register.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@antv_g-base@0.4.7@@antv/g-base/lib/bbox/register.js
// module id = E/14
// module chunks = 14